var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jh-version"},[_vm._v("健恒医疗Ver: 1.1.5")])
}
var staticRenderFns = []

export { render, staticRenderFns }